import { render, staticRenderFns } from "./bottomTip.vue?vue&type=template&id=5c0db7fb&scoped=true"
import script from "./bottomTip.vue?vue&type=script&lang=js"
export * from "./bottomTip.vue?vue&type=script&lang=js"
import style0 from "./bottomTip.vue?vue&type=style&index=0&id=5c0db7fb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c0db7fb",
  null
  
)

export default component.exports